module.exports = __webpack_public_path__ + "img/loginwout.949ff8af.png";